import {
  Button,
  Card,
  Dropdown,
  Input,
  message,
  Space,
  Table,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import {
  DeleteOutlined,
  DownloadOutlined,
  MoreOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { formatDate } from "../../util/helper";
import ExporterPortPairUploadStatus from "./ExporterPortPairUploadStatus";

const ExporterPortPairList = () => {
  const dispatch = useDispatch();
  const [exporterPairedLists, setExporterPairedLists] = useState(null);
  const currentPage = 1;
  const dataSize = 10;
  const authUser = useSelector(({ auth }) => auth.userData);
  const token = authUser.token;

  const getExporterPortPairList = async (page, limit) => {
    dispatch(fetchStart());
    const response = await axiosInstance.get(
      `${BASE_API_CONFIG.baseURL}/admin/exporter-Port-Pair-List?page=${page}&limit=${limit}`
    );
    setExporterPairedLists(response?.data?.data);
    dispatch(fetchSuccess());
  };

  useEffect(() => {
    getExporterPortPairList(currentPage, dataSize);
  }, []);

  const uploadProps = {
    name: "file",
    accept: ".xlsx,.xls",
    action: `${BASE_API_CONFIG.baseURL}/admin/upload-exporter-port-pairs-xl`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    showUploadList: false,
    onChange(info) {
      if (info.file.status === "uploading") {
        console.log("Uploading:", info.file.name);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} uploaded successfully`);
        getExporterPortPairList(currentPage, dataSize);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} upload failed.`);
      }
    },
  };

  const onShowSizeChange = (current, pageSize) => {
    getExporterPortPairList(current, pageSize);
  };
  const tableData = exporterPairedLists;

  const handleDownload = async (id) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/admin/download-exporter-port-pairs/${id}`,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const blob = new Blob([response.data], {
        type: response.headers["Content-Type"],
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `exporter_port_pairs_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error("Download failed");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(
        `${BASE_API_CONFIG.baseURL}/admin/exporter-Port-Pair/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      message.success("Deleted successfully");
      getExporterPortPairList(currentPage, dataSize);
    } catch (error) {
      message.error("Delete failed");
    }
  };
  const columns = [
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "25%",
      render: (date) => <div>{formatDate(date)}</div>,
    },
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <ExporterPortPairUploadStatus status={status} />,
    },
    {
      title: "Download Excel",
      key: "downloadExcel",
      align: "center",
      render: (record) => (
        <DownloadOutlined
          onClick={() => handleDownload(record.id)}
          style={{ cursor: "pointer", fontSize: 18 }}
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <div
          className="myexim-action-icon"
          onClick={(e) => e.stopPropagation()}
        >
          <Dropdown
            menu={{
              items: [
                {
                  label: "Delete",
                  key: "1",
                  icon: <DeleteOutlined />,
                  onClick: () => {
                    handleDelete(record?.id);
                  },
                },
              ],
            }}
            trigger={["click"]}
          >
            <Space>
              <MoreOutlined style={{ cursor: "pointer" }} />
            </Space>
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <Card
      title={
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="myexim-table-title">Exporter Port Pair</div>

            <div>
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>Upload Excel</Button>
              </Upload>
            </div>
          </div>
        </div>
      }
      style={{ width: "100%" }}
    >
      <div>
        <Table
          className="gx-table-responsive my-product-table myexim-table"
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            pageSize: 10,
            total: tableData?.count,
            onChange: onShowSizeChange,
          }}
          columns={columns}
          dataSource={tableData?.rows}
        />
      </div>
    </Card>
  );
};

export default ExporterPortPairList;
